export { InfoBar } from './infoBar'
